import React, { forwardRef } from 'react';
import './Input.css';

export interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  hint?: string;
  fullWidth?: boolean;
}

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(({
  label, error, hint, fullWidth = true, className = '', id, ...props
}, ref) => {
  const textareaId = id || `textarea-${label?.toLowerCase().replace(/\s+/g, '-')}`;
  return (
    <div className={`ui-input-group ${fullWidth ? 'ui-input-full' : ''} ${error ? 'ui-input-error' : ''} ${className}`}>
      {label && <label htmlFor={textareaId} className="ui-input-label">{label}</label>}
      <textarea ref={ref} id={textareaId} className="ui-input ui-textarea" rows={4} {...props} />
      {error && <span className="ui-input-error-text">{error}</span>}
      {hint && !error && <span className="ui-input-hint">{hint}</span>}
    </div>
  );
});
TextArea.displayName = 'TextArea';
